import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AlertaOSComplementarOutput, AlertaUsuarioOutput, MensagemUsuarioOutput } from '../models/alerta-usuario';

@Injectable({
  providedIn: 'root',
})
export class AlertaUsuarioService {
  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore + "AlertaUsuario/";
  }

  // #region Alerta

  getAlertaUsuario(): Observable<AlertaUsuarioOutput[]> {
    return this.httpClient.get<AlertaUsuarioOutput[]>(
      `${this.environmentUrl}Alerta`);
  }

  setAlertaUsuario(idsAlerta: string[]): Observable<boolean> {
    return this.httpClient.post<boolean>(
      `${this.environmentUrl}Alerta`, idsAlerta);
  }

  verificaExisteAlerta(): Observable<number> {
    return this.httpClient.get<number>(
      `${this.environmentUrl}Alerta/VerificaSeExisteAlerta`);
  }

  // #endregion Alerta

  // #region Alerta OS Complementar

  getAlertaOSComplementar(): Observable<AlertaOSComplementarOutput[]> {
    return this.httpClient.get<AlertaOSComplementarOutput[]>(
      `${this.environmentUrl}OsComplementar`);
  }

  setAlertaOSComplementar(idsAlerta: string[]): Observable<boolean> {
    return this.httpClient.post<boolean>(
      `${this.environmentUrl}OsComplementar`, idsAlerta);
  }

  // #endregion Alerta OS Complementar  

  // #region Mensagem

  getMensagem(): Observable<MensagemUsuarioOutput[]> {
    return this.httpClient.get<MensagemUsuarioOutput[]>(
      `${this.environmentUrl}Mensagem`);
  }

  setMensagem(idAtividade: number): Observable<boolean> {
    return this.httpClient.post<boolean>(
      `${environment.ApiCore}Mensagem`, idAtividade);
  }

  // #endregion Mensagem
}